import { CmsPageGuards } from './cms-page.guard';

export const guards: any[] = [CmsPageGuards];

export * from './cms-page.guard';
